import React from 'react';
import { AlertCircle } from 'react-feather';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import { sanitizePropertyValue } from '../../theme/styles';
import './Tooltip.css';

export class Tooltip extends React.PureComponent {
    render() {
        const {
            id,
            placement,
            content,
            delay,
            trigger,
            children,
            className,
        } = this.props;

        return (
            <OverlayTrigger
                key={id}
                placement={placement}
                delay={delay}
                trigger={trigger}
                overlay={(
                    <BootstrapTooltip id={`tooltip-${id}`} className={['toolTipText', className || ''].filter(Boolean).join(' ')}>
                        {content}
                    </BootstrapTooltip>
                )}
            >
                {children || <AlertCircle id="tooltipInfoPopupIcon" size={18} color={sanitizePropertyValue('--primaryAction')} />}
            </OverlayTrigger>
        );
    }
}

export default Tooltip;
